import GymRatingBrenchPressRepository from '@/shared/http/repositories/socialProject/gymRating-brenchpress'
import MeasurementRepository from '@/shared/http/repositories/socialProject/student-measurement'
import GymRatingRepository from '@/shared/http/repositories/socialProject/gymRating'
import GymRatingBrenchPressModel from '@/shared/models/gymRatingBrenchPress'
import MeasurementModel from '@/shared/models/measurementModel'
import { loading, toast } from '@/shared/utils/UIHelper'
import { IsSuccessCode } from '@/shared/utils/API'
import download from 'downloadjs'

export default {
  name: 'GymBrenchPress',

  props: {
    items: {
      type: Object,
      default: {}
    }
  },

  data: () => ({
    gymRatingBrenchPress: new GymRatingBrenchPressModel(),
    measurement: new MeasurementModel(),
    emptyText: 'Não há nada para exibir',
    classAverageFeminine: 0,
    totalRegister: 0,
    classAverage: 0,
    studentsBrenchPress: [],
    literature: null,
    studentId: null,
    studentName: '',
    selected: {},
    enableExportButtonFemale: false,
    showModalDeleteBrenchPress: false,
    showInputBrenchPress: false,
    showModalMeasurement: false,
    fieldsGymBrenchPress: [
      {
        key: 'studentName',
        label: 'NOME',
        class: 'left-header-border text-center',
        sortable: true
      },
      {
        key: 'weight',
        label: 'PESO CORPORAL (KG)',
        class: 'middle-header text-center'
      },
      {
        key: 'brenchPress',
        label: 'SUPINO',
        class: 'middle-header text-center',
        sortable: true
      },
      {
        key: 'percentWeight',
        label: '% AO PESO',
        class: 'middle-header text-center',
        formatter: 'calculatePercentWeight'
      },
      {
        key: 'situation',
        label: 'RELAÇÃO',
        class: 'middle-header text-center',
        formatter: 'checkSituation'
      },
      {
        key: 'action',
        label: 'AÇÕES',
        class: 'right-header-border text-center'
      }
    ],
    pagination: {
      count: 1,
      limit: 15,
      index: 1
    }
  }),

  watch: {
    items: {
      handler: function (value) {
        if (value.id) {
          this.GetByGymRatingId(value.id)
        }
      },
      immediate: true
    }
  },

  computed: {
    
  },

  created() {
    
  },

  methods: {
    GetByGymRatingId(id) {
      loading.push()
      GymRatingBrenchPressRepository.GetGymRatingBrenchPressByGymRatingId(id, this.pagination)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.studentsBrenchPress = res.data.data

          const haveStudentFemale = this.studentsBrenchPress.find(x => x.studentGender == 'Feminino')
          if (haveStudentFemale && this.items.category == 'JUNIOR E SENIOR') {
            this.enableExportButtonFemale = true
            this.$emit('onShowGraphicBrenchPressFeminine', true)
          } 
          else {
            this.enableExportButtonFemale = false
            this.$emit('onShowGraphicBrenchPressFeminine', false)
          }

          this.pagination = {
            count: res.data.count,
            limit: res.data.pagingLimit,
            index: res.data.pagingIndex
          }

          if (res.data.count > 0) {
            this.totalRegister = res.data.count
          } else {
            this.totalRegister = 0
          }

          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tabela de supino', 'ERRO')
        })
    },

    GetById() {
      loading.push()
      GymRatingBrenchPressRepository.GetById(this.gymRatingBrenchPress.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.gymRatingBrenchPress = new GymRatingBrenchPressModel(res.data.data)

          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tabela de supino', 'ERRO')
        })
    },

    onSaveCreate(text) {
      if (text == 'yesValidation') {
        const brenchPress = this.gymRatingBrenchPress.brenchPress
        const weight = this.gymRatingBrenchPress.weight
  
        if (!brenchPress || !weight) {
          toast.info('Preencha os campos', 'AVISO')
          return
        }
      }

      loading.push()
      GymRatingBrenchPressRepository.Update(this.gymRatingBrenchPress)
        .then(result => {
          if (!IsSuccessCode(result)) return Promise.reject()
          this.showInputBrenchPress = false
          this.$emit('reloadGraphicBrenchPress', this.items.id, this.items.category)

          if (text == 'yesValidation') {
            this.GetByGymRatingId(this.items.id)
          }
          
          loading.pop()
        })
        .catch(() => {
          toast.error('Não foi possível salvar registro.', 'ERRO')
          loading.pop()
        })
    },

    downloadExcel() { // Juvenil, Junior e Senior - Masculino
      const category = this.items.category

      if (category == 'JUVENIL I' || category == 'JUVENIL II') this.literature = this.items.juvenileBrenchpressLiterature

      if (category == 'JUNIOR E SENIOR') this.literature = this.items.masculineBrenchpressLiterature

      loading.push()
      GymRatingBrenchPressRepository.ExportExcelJuvAndSeniorMasculine(this.items.id, this.classAverage, this.literature, this.items.category, this.items.className)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          if(res.data.data === null) {
            toast.warning('Esta consulta não tem registros e não irá gerar planilha')
            loading.pop()
            return Promise.resolve()
          }

          const file = res.data.data
          const base64 = `data:${file.contentType};base64,${file.base64}`
          download(base64, file.alias, file.contentType)
          
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao exportar excel', 'ERRO')
        })
    },

    downloadExcelFemale() { // Junior e Senior - Feminino
      const category = this.items.category

      if (category == 'JUVENIL I' || category == 'JUVENIL II') return

      this.literature = this.items.feminineBrenchpressLiterature

      loading.push()
      GymRatingBrenchPressRepository.ExportExcelSeniorFeminine(this.items.id, this.classAverageFeminine, this.literature, this.items.category, this.items.className)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          if(res.data.data === null) {
            toast.warning('Esta consulta não tem registros e não irá gerar planilha')
            loading.pop()
            return Promise.resolve()
          }

          const file = res.data.data
          const base64 = `data:${file.contentType};base64,${file.base64}`
          download(base64, file.alias, file.contentType)
          
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao exportar excel', 'ERRO')
        })
    },

    createStudentMeasurement() {
      const height = this.measurement.height
      const weight = this.measurement.weight

      if (!height || !weight) {
        toast.info('Preencha os campos', 'AVISO')
        return
      }

      this.gymRatingBrenchPress.weight = weight

      loading.push()
      MeasurementRepository.Create(this.studentId, this.measurement)
      .then(res => {
        if (!IsSuccessCode(res)) return Promise.reject()
        
        this.gymRatingBrenchPress.brenchPress = null
        this.onSaveCreate('noValidation')

        this.onSaveWeightCategories(this.items.id, this.studentId, this.gymRatingBrenchPress.weight, this.measurement.height)

        this.showModalMeasurement = false
        
        toast.success('Medida criada com sucesso!', 'CRIAÇÃO DE MEDIÇÃO')
        loading.pop()
        return Promise.resolve()
      })
      .catch(() => {
        loading.pop()
        toast.error('Erro ao criar medida', 'ERRO')
      })
    },

    onSaveWeightCategories(gymRatingId, studentId, weight, height) {
      loading.push()
      GymRatingRepository.SaveWeightOnTables(gymRatingId, studentId, weight, height)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.onClearModalMeasurement()
          this.onClearModalInputBrenchPress()
          
          this.GetByGymRatingId(this.items.id)
          this.$emit('reloadAllTables')

          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao salvar peso nas tabelas', 'ERRO')
        })
    },

    checkModal(item) {
      this.gymRatingBrenchPress.id = item.id
      this.studentName = item.studentName

      if (item.weight == null) {
        this.studentId = item.studentId
        this.measurement.height = null
        this.measurement.weight = null
        this.showModalMeasurement = true
        return
      }

      this.studentId = null
      this.GetById()
      this.showInputBrenchPress = true
    },

    calculatePercentWeight(value, key, item) {
      const weight = item.weight
      const brenchPress = item.brenchPress
      
      if (!brenchPress || !weight){
        return value = '-'
      }

      const calc1 = item.brenchPress / item.weight
      const calc2 = calc1 * 100
      const result = Number.parseFloat(calc2).toFixed(2)

      return value = `${result} %`
    },

    checkSituation(value, key, item) {
      const weight = item.weight
      const brenchPress = item.brenchPress
      
      if (!brenchPress || !weight){
        return value = '-'
      }

      const category = this.items.category

      const calc1 = item.brenchPress / item.weight
      const calc2 = calc1 * 100
      const result = Number.parseFloat(calc2).toFixed(2)

      if (category === 'JUVENIL I' || category === 'JUVENIL II') {
        const literature = this.items.juvenileBrenchpressLiterature
        const literaturePercent = literature * 100

        if (result > literaturePercent) {
          const text = 'Acima do Esperado'
          return value = text
        }

        if (result == literaturePercent) {
          const text = 'Na Média'
          return value = text
        }

        if (result < literaturePercent) {
          const text = 'Abaixo do Esperado'
          return value = text
        }
      }

      if (item.studentGender == 'Feminino') {
        const literatureFeminine = this.items.feminineBrenchpressLiterature
        const literaturePercent = literatureFeminine * 100

        if (result > literaturePercent) {
          const text = 'F/ - Acima do Esperado'
          return value = text
        }

        if (result == literaturePercent) {
          const text = 'F/ - Na Média'
          return value = text
        }

        if (result < literaturePercent) {
          const text = 'F/ - Abaixo do Esperado'
          return value = text
        }
      }

      if (item.studentGender == 'Masculino') {
        const literatureMasculine = this.items.masculineBrenchpressLiterature
        const literaturePercent = literatureMasculine * 100
        
        if (result > literaturePercent) {
          const text = 'M/ - Acima do Esperado'
          return value = text
        }

        if (result == literaturePercent) {
          const text = 'M/ - Na Média'
          return value = text
        }

        if (result < literaturePercent) {
          const text = 'M/ - Abaixo do Esperado'
          return value = text
        }
      }
    },

    onDelete() {
      loading.push()
      GymRatingBrenchPressRepository.Delete(this.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.GetByGymRatingId(this.items.id)
          this.onCloseModalDeleteBrenchPress()
          toast.success('Média zerada com sucesso!', 'EXCLUSÃO DE MÉDIA')
          this.$emit('reloadGraphicBrenchPress', this.items.id, this.items.category)
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao excluir um Supino', 'ERRO')
        })
    },

    clearDrawer() {
      this.studentsBrenchPress = []
      this.totalRegister = 0
      this.gymRatingBrenchPress = new GymRatingBrenchPressModel()
      this.selected = {}
    },

    onCloseModalDeleteBrenchPress() {
      this.selected = {}
      this.showModalDeleteBrenchPress = false
    },

    selectRow(item) {
      this.showModalDeleteBrenchPress = true
      this.selected = item
      this.id = item.id
    },

    onClearModalInputBrenchPress() {
      this.gymRatingBrenchPress.weight = null
      this.gymRatingBrenchPress.brenchPress = null
      this.showInputBrenchPress = false
    },

    onClearModalMeasurement() {
      this.measurement = new MeasurementModel()
      this.showModalMeasurement = false
    }
  }
}